import DeleteOcrProvider from './DeleteOcrProvider';

type ConfirmModalSubComponents = {
  DeleteOcrProvider: typeof DeleteOcrProvider;
};

const ConfirmModal: ConfirmModalSubComponents = () => null;

ConfirmModal.DeleteOcrProvider = DeleteOcrProvider;

export default ConfirmModal;
